import { render } from "./datesList.vue?vue&type=template&id=b82546fa"
import script from "./datesList.vue?vue&type=script&lang=js"
export * from "./datesList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/grgnd.webweb.works/client/grapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__